export default __webpack_public_path__ + "static/documentation-global-header-04-1a4d213dbf427533e5c2fb52fc5ec618.jpg";